import { IWorkoutCacheEntry } from './homeworkoutcachingalgo';

// used only for testing - help mock failing or succedding caching
export class StubWorkoutCacheEntry implements IWorkoutCacheEntry {

    public static Populate(
        stubData: string[],
        cachingProcessIdentifier: number): IWorkoutCacheEntry[] {
        const stubEntries: IWorkoutCacheEntry[] = [];
        for (let index = 0; index < stubData.length; index++) {
            const name = stubData[index];
            stubEntries.push(new StubWorkoutCacheEntry(name, index, cachingProcessIdentifier));
        }
        return stubEntries;
    }

    public indexesThatAreDuplicates: number[];
    private waitUntilMarkedAsCompleted: Promise<boolean>;
    private markAsComplete: (completedSuccess: boolean) => void;

    constructor(
        public readonly name: string,
        public readonly index: number,
        public readonly cachingProcessIdentifier: number,
    ) {
        this.resetDeferredResolve();
    }

    public async completeWaitingCache() {
        this.markAsComplete(true);
        this.resetDeferredResolve();
    }
    public async failWaitingCache() {
        this.markAsComplete(false);
        this.resetDeferredResolve();
    }
    public async startCache(): Promise<void> {
        const completedSuccess = await this.waitUntilMarkedAsCompleted;
        if (!completedSuccess) {
            throw new Error('stub startCache failed as planned');
        }
    }
    private resetDeferredResolve() {
        let deferredResolve: (completedSuccess: boolean) => void | null = (b) => { return; };
        this.waitUntilMarkedAsCompleted = new Promise<boolean>((resolve, reject) => {
            deferredResolve = resolve;
        });
        this.markAsComplete = deferredResolve;
    }
}
